import axios from "axios";
import {errorHandler} from "@/services/errorHandler";

export default {
    name: "locations",
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        getRegion(context,) {
            const api = context.getters.getApiKey;
            return axios.get(`${PaymentGateway}regions/getByApiKey?apiKey=${api}`)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err) )
        },
        getAllBranches(context,id) {
            const currentUser = JSON.parse(localStorage.getItem('current_user'));
            const apiKey = currentUser?.companyApiKey;
            return axios.get(`${PaymentGateway}regions/getBranchesByApiKey?apiKey=${apiKey}&archived=false`)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err) )
        },
        createBranch(context, payload) {
            const currentUser = JSON.parse(localStorage.getItem('current_user'));
            const apiKey = currentUser?.companyApiKey;
            const url = `${PaymentGateway}regions/createBranch`
            const method = `post`
            return context.dispatch('sendRequest',{url, payload,method})
        },
        createRegion(context, payload) {
            payload.apiKey = context.getters.getApiKey
            const url = `${PaymentGateway}regions/create`
            const method = `post`
            return context.dispatch('sendRequest',{url, payload,method})
        },
        archiveBranch(context, payload) {
            const url = `${PaymentGateway}regions/archiveBranch`
            const method = `put`
            return context.dispatch('sendRequest',{url, payload,method})
        },
        archiveRegion(context, payload) {
            const url = `${PaymentGateway}regions/archiveRegion`
            const method = `put`
            return context.dispatch('sendRequest',{url, payload,method})
        },
    }
}
